import React from 'react';

import url from './oauth-url';

class Start extends React.PureComponent {
  componentDidMount() {
    window.location = url; // redirect to OAuth login
  }

  render() {
    return null;
  }
}

export default Start;
